import { render } from "./SurveyProgressBar.vue?vue&type=template&id=6b20c668&scoped=true"
import script from "./SurveyProgressBar.vue?vue&type=script&lang=js"
export * from "./SurveyProgressBar.vue?vue&type=script&lang=js"

import "./SurveyProgressBar.vue?vue&type=style&index=0&id=6b20c668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b20c668"]])

export default __exports__